import { mapEditorialContent } from '@cobalt/utilities';
import uefaAxios from '@core/axios';
import LivePollingInstance from '@live/pollingHandler';
import { language, IS_SIMULATION } from '@utilities/browser';
import { getCookie, removeCookie, setCookie } from '@utilities/cookies';
import { cobaltApiKey } from '@utilities/WindowContext';

export const cookieName = 'audio-active';
const cookieOptions = {
  path: '/',
  domain: location.hostname === 'localhost' ? 'localhost' : '.uefa.com',
} as const;

export default class AudioService {
  static set open(toggle) {
    toggle
      ? setCookie(cookieName, true, { ...cookieOptions, expires: 1 / (24 * 60 * 20) }) // two seconds expire time
      : removeCookie(cookieName, cookieOptions);
  }

  static get open() {
    return !!getCookie(cookieName);
  }

  static subscribe(
    interval: number,
    callback: (result: { active: boolean; streamUrl?: string }) => void,
    context: any = this,
  ) {
    const apiUrl = `${
      window.cobaltApiUrl
    }pages?aggregator=lightpagejson&url=${window.competitionTracking?.toUpperCase()}.AUDIOSHOW.LIVE/${language?.toUpperCase()}`;

    LivePollingInstance.on(
      apiUrl,
      [{ key: 'x-api-key', value: cobaltApiKey }],
      interval,
      async (response) => {
        const result = await AudioService.process(response);
        callback(result);
      },
      context,
    );
  }

  static async process(response: any) {
    if (IS_SIMULATION) {
      return {
        active: true,
        streamUrl: 'https://wowzaec2demo.streamlock.net/live/bigbuckbunny/playlist.m3u8',
      };
    }

    if (!response) {
      return { active: false };
    }
    const article = mapEditorialContent(response?.model?.data);
    const streamUrl = article?.body
      ?.find((part) => part._type === 'EXTRA' && part._attributes['emk-class'] === 'livestream')
      ?._json?.find((part) => part._type === 'LINK' && part._attributes['emk-type'] === 'extra-content-headline')
      ?._attributes?.href;

    const isStreamAvailable =
      !!streamUrl &&
      (await uefaAxios.head(streamUrl).then(
        () => true,
        () => false,
      ));
    return { active: isStreamAvailable, streamUrl };
  }
}
